//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import add from './add.vue';
import { data as shbjData, getLabelByKey as getShbjLabelByKey, getTypeByKey as getShbjTypeByKey } from './data/shbj.js';

import DialogAuditTask from './components/dialog-audit-task.vue';
import DialogAuditSettleSetting from './components/dialog-audit-settle-setting.vue';

export default {
    props: [],
    components: { add, DialogAuditTask, DialogAuditSettleSetting },
    data: function () {
        return {
            setIsDwadmin: this.$store.getters.user.isDwadmin, //本地存的
            //搜索条件
            pgData: {
                shbj: '',
                dwname: '',
                xzqycode: '',
                refereeusername: '',
            },

            tableData: [],

            shbjList: shbjData,
            formTitle: '',
            dwcode: '',
            dialogAddVisible: false,
            tableHeight: window.innerHeight - 210,

            dialogAuditTaskVisible: false,
            auditTaskFlowId: '',
        };
    },
    computed: {},
    watch: {
        dialogAddVisible: function (n, o) {
            if (n == false) {
                this.reloadHandler();
            }
        },
    },

    methods: {
        //搜索
        search: function () {
            this.reloadHandler();
        },
        detaildw: function (row) {
            if (this.getQuery('token')) {
                this.goto({
                    path: './detail',
                    query: {
                        dwcode: row.dwcode,
                        token: this.getQuery('token'),
                    },
                });
            } else {
                this.goto({
                    path: './detail',
                    query: {
                        dwcode: row.dwcode,
                    },
                });
            }
        },
        auditHandler(row) {
            this.$prompt('请填写审核备注', '审核', {
                confirmButtonText: '通过',
                cancelButtonText: '退回',
                distinguishCancelAndClose: true,
                callback: (action, instance) => {
                    if (action === 'close') {
                        return;
                    }

                    var { inputValue } = instance,
                        shbj = 1;

                    if (action === 'cancel') {
                        shbj = 2;
                    }

                    this.$post(
                        `${this.getGetters('indexUrl')}/channel/channelInfo/auditPartner`,
                        {
                            dwcode: row.dwcode,
                            shbj,
                            auditremark: inputValue,
                        },
                        () => {
                            this.reloadHandler();
                        },
                        true,
                    );
                },
            });
        },

        adddw: function () {
            this.dialogAddVisible = true;
            this.formTitle = '添加渠道';
            this.dwcode = '';
        },
        editdw: function (row) {
            this.dialogAddVisible = true;
            this.formTitle = '编辑渠道';
            this.dwcode = row.dwcode;
        },
        deldw: function (row) {
            var that = this;

            ShowConfirm(
                '是否删除当前渠道',
                'warning',
                function () {
                    that.$delete(that.$store.getters.partnerUrl + '/channelInfo/' + row.dwcode, {}, function (data) {
                        ShowMsg('删除成功', 'success');
                        that.reloadHandler();
                    });
                },
                function () {
                    ShowMsg('已取消删除操作', 'info');
                },
            );
        },

        //获取列表
        reloadHandler: function () {
            this.$refs.page.reload();
        },
        afterQuery() {
            this.$refs.table.doLayout();
        },

        //复制
        handleCopy: function (index, row) {
            this.copyData = row.weburl + '?partnerid=' + row.dwcode;
            this.copy(this.copyData);
        },
        copy: function (data) {
            let url = data;
            let oInput = document.createElement('input');

            oInput.value = url;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象;
            document.execCommand('Copy'); // 执行浏览器复制命令
            ShowMsg('复制成功', 'success');
            oInput.remove();
        },

        getShbjLabelByKey,
        getShbjTypeByKey,

        detailAuditTask(row) {
            this.auditTaskFlowId = row.auditFlowId;
            this.dialogAuditTaskVisible = true;
        },
    },
    mounted() {
        console.log(this.$store.getters.user);
    },
};
